module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@2x-917c4ab686e869ad08ac7632e94e6e15.png";